export default __webpack_public_path__ + "static/media/Capitolo 3.be25d41e.mp3";